import { useCallback } from 'react'
import { usePersistedState } from '../../api/localStore'
import { CareTeamTemplate, RoleCategoryId } from './types'

const EMPTY: CareTeamTemplate = { categoryIds: [] }

const keyFor = (programId: string) => `advanced.careTeam.template.${programId}.v2`

export type CareTeamTemplateState = {
  template: CareTeamTemplate
  addCategory: (categoryId: RoleCategoryId) => void
  removeCategory: (categoryId: RoleCategoryId) => void
}

export const useCareTeamTemplate = (programId: string): CareTeamTemplateState => {
  const [template, setTemplate] = usePersistedState<CareTeamTemplate>(keyFor(programId), EMPTY)

  const addCategory = useCallback(
    (categoryId: RoleCategoryId) => {
      if (template.categoryIds.includes(categoryId)) {
        return
      }
      setTemplate({ ...template, categoryIds: [...template.categoryIds, categoryId] })
    },
    [setTemplate, template]
  )

  const removeCategory = useCallback(
    (categoryId: RoleCategoryId) => {
      setTemplate({
        ...template,
        categoryIds: template.categoryIds.filter((id) => id !== categoryId),
      })
    },
    [setTemplate, template]
  )

  return { template, addCategory, removeCategory }
}
